
import { InboxreaderService } from "@/services/inboxreader-service";
import { InboxreaderPurchase } from "@/utils/purchase/inboxreader-purchase";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			value: "",
			saving: false
		};
	},
	props: {
		purchase: {
			type: Object as ()=>InboxreaderPurchase,
			required: true
		}
	},
	watch: {
		file: {
			immediate: true,
			handler(){
				this.value = this.purchase.NoteForBookkeeper;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.saving) return;
			try{
				this.saving = true;
				await InboxreaderService.setNoteForBookkeeper(this.purchase.ID, this.value);
				this.purchase.NoteForBookkeeper = this.value;
				this.close();
			}finally{
				this.saving = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
